/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Contracts from './Contracts/index'
import No from './No/index'
import PaymentPlans from './PaymentPlans/index'
import React from 'react'
import TreatmentPlanTemplates from './TreatmentPlanTemplates/index'
import TreatmentPlans from './TreatmentPlans/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let wizardCurrentStepValueData = fromData.useDataValue({ viewPath,
context: 'wizard',
path: 'current_step',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: wizardCurrentStepValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentPlanTemplates'}>
<TreatmentPlanTemplates
  viewPath={`${viewPath}/TreatmentPlanTemplates`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentPlans'}>
<TreatmentPlans
  viewPath={`${viewPath}/TreatmentPlans`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentPlans'}>
<PaymentPlans
  viewPath={`${viewPath}/PaymentPlans`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Contracts'}>
<Contracts
  viewPath={`${viewPath}/Contracts`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}